export default {
  predictions: [],
}
